<form [formGroup]="restSchuldenFG">
    <div *ngIf="restschulden.length > 0">
        <div formArrayName="restschulden">
            <div *ngFor="let item of restschulden.controls; let i = index"
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Omschrijving' : ''"
                                                class="custom-input-250 col-auto"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-date-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Aanvangsdatum' : ''"
                                                class="custom-input-150 col-auto"
                                                formControlName="aanvangsDatum"
                                                id="aanvangsDatum"
                                                placeholder="dd-mm-jjjj"
                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                class="custom-input-250 col-auto"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Hoofdsom 1-1' : ''"
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="hoofdsom0101"
                                                  id="hoofdsom0101"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Hoofdsom 31-12' : ''"
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="hoofdsom3112"
                                                  id="hoofdsom3112"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Betaalde rente' : ''"
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="rente"
                                                  id="rente"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-button (click)="deleteRestschuld(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                     class="delete"
                                     iconType="light"
                                     icon="trash"
                                     id="buttonDelete"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
            </div>
        </div>
    </div>

    <div *ngIf="restschulden.length === 0">
        <snelstart-ui-button (click)="addRestschuld()" class="snelstart-ui-button" icon="plus"
                             type="link">Restschuld invullen
        </snelstart-ui-button>
    </div>
    <div *ngIf="restschulden.length > 0">
        <snelstart-ui-button (click)="addRestschuld()" class="snelstart-ui-button" icon="plus"
                             type="link">Restschuld toevoegen
        </snelstart-ui-button>
    </div>
</form>
